import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import classes from "./ProgressBar.module.css";

const ProgressBar = (props) => {
  const { className, progress, target } = props;
  const barRef = useRef();

  useEffect(() => {
    if (barRef.current) {
      barRef.current.style.setProperty(
        "--bar-before-width",
        `${
          progress <= 0
            ? 0
            : progress >= target
            ? 100
            : (progress / target) * 100
        }%`
      );
    }
  }, [progress, target]);

  return (
    <div
      className={classNames(
        classes["progress-bar"],
        {
          [classes["progress-bar--done"]]: progress >= target,
        },
        className
      )}
      ref={barRef}
    />
  );
};

export default ProgressBar;

ProgressBar.propTypes = {
  className: PropTypes.string,
  progress: PropTypes.number,
  target: PropTypes.number,
};
